export const SR_COMBOS_IDS = ['tipo_mercado', 'estados_sr']
